import classNames from 'classnames';
import { useCallback } from 'react';
import {
    useCurrentModelStateValue,
    useSetCurrentModelState,
} from '@/shared/components/configurator/atoms/current-model-state';
import { CONFIGURATOR_WALL_COLOR_DEFAULT } from '@/shared/config/const';
import useDebouncedFunction from '@/shared/hooks/use-debounced-function';
import ColorPicker from '../ColorPicker';

const presets = [
    '#FF0000',
    '#FF9900',
    '#FFFF00',
    '#03FF00',
    '#38761D',
    '#01154D',
    '#0000FF',
    '#9900FF',
    '#000000',
    '#CC0000',
    '#FFC266',
    '#FFFF66',
    '#46C120',
    '#9DE080',
    '#0230B0',
    '#9999FF',
    '#C266FF',
    '#FFFFFF',
];

const ColorInput = () => {
    const onChange = useDebouncedFunction((color: string) => {
        setCurrentModelState((prev) => {
            const newColor = [...prev.color.value];

            if (typeof currentModelState.openedWallColorPickerIndex === 'number') {
                newColor[currentModelState.openedWallColorPickerIndex] = color;
            }

            return {
                ...prev,
                color: {
                    value: newColor,
                    title: color,
                },
            };
        });
    }, 100);

    const onColorChange = useCallback((color: string) => onChange(color), [onChange]);

    const currentModelState = useCurrentModelStateValue();
    const setCurrentModelState = useSetCurrentModelState();

    if (typeof currentModelState.openedWallColorPickerIndex !== 'number') {
        return null;
    }

    const color =
        currentModelState.color.value[currentModelState.openedWallColorPickerIndex] || CONFIGURATOR_WALL_COLOR_DEFAULT;

    return (
        <div className="color-picker-wrapper">
            <ColorPicker onColorChange={onColorChange} color={color} />

            <ul className="presets-list list-unstyled">
                {presets.map((preset, i) => {
                    return (
                        <li key={i}>
                            <button
                                className={classNames('color-preset', {
                                    'color-preset--white': preset.toLowerCase() === '#ffffff',
                                    'color-preset--active': preset.toLowerCase() === color.toLowerCase(),
                                })}
                                style={{ backgroundColor: preset }}
                                onClick={() => {
                                    setCurrentModelState((prev) => {
                                        const newColor = [...prev.color.value];

                                        if (typeof currentModelState.openedWallColorPickerIndex === 'number') {
                                            newColor[currentModelState.openedWallColorPickerIndex] = preset;
                                        }

                                        return { ...prev, color: { title: preset, value: newColor } };
                                    });
                                }}
                            />
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default ColorInput;
